<template>
  <index-page
    :custom-action-data="customActionData"
    :errors="errors"
    :meta="meta"
    :models="models"
    :nav-items="aspectMenuItems"
    :toasts="toasts"
  >
  </index-page>
</template>

<script>
import IndexPage from '@/structures/default/Pages/Models/Index';

export default {
  components: {
    IndexPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    models: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    customActionData: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
